import './altman/style';
import FormStructure from './altman/form_structure';

export default FormStructure;